// Shared content for all 3 GoKosher luxury designs
import { Flame, Droplet, Wind, ChefHat, Building2, Home, MessageCircle, Phone } from "lucide-react";

export const SERVICES = [
  { num: "01", name: "Kitchen Kashering", desc: "Full residential kitchen — countertops, sinks, ovens, hobs.", icon: Flame },
  { num: "02", name: "Pesach Preparation", desc: "Annual Passover kitchen prep, strict standard.", icon: Wind },
  { num: "03", name: "Tovling Keilim", desc: "Collection & return mikveh service for new utensils.", icon: Droplet },
  { num: "04", name: "Hagalah", desc: "Professional utensil kashering, returned same day.", icon: ChefHat },
  { num: "05", name: "Commercial Certification", desc: "Restaurants, hotels, caterers, schools, event venues.", icon: Building2 },
  { num: "06", name: "BBQ Kashering", desc: "Libun gamur via professional flame for outdoor grills.", icon: Flame },
  { num: "07", name: "New Home Package", desc: "Complete moving-in service — kashering, mezuzot, tovling.", icon: Home },
  { num: "08", name: "Halacha Consultation", desc: "Direct rabbinic counsel. One-on-one learning on kashrut and other topics.", icon: MessageCircle },
];

export const PROCESS = [
  { num: "01", title: "Site Visit", desc: "We attend your home or premises, assess every surface and appliance, and explain exactly what's possible." },
  { num: "02", title: "Estimate", desc: "A clear written estimate — no surprises. Including the standard applied and the time required." },
  { num: "03", title: "Kashering", desc: "We arrive fully equipped, complete the work to your minhag, and provide written certification." },
];

export const GOOD_TO_KNOW = [
  { q: "Can my granite worktops be kashered?", a: "In most cases, yes. Granite is a hard, non-porous stone and can be kashered with hagalah. We'll assess on site." },
  { q: "What about my oven — including self-clean?", a: "Yes. Most ovens kasher beautifully, especially those with a self-clean or pyrolytic cycle. We bring everything required." },
  { q: "Can I keep my dishwasher?", a: "Usually yes, with the proper kashering procedure. Stainless steel interiors are ideal." },
  { q: "And my marble?", a: "Marble cannot be kashered with heat — but we cover it for Pesach with bespoke fitted boards and a kosher-compliant finish." },
];

export const FAQ = [
  { q: "What is kashering and why is it necessary?", a: "Kashering (hechsher keilim) is the process of making a kitchen or utensil kosher by removing absorbed non-kosher taste through heat or immersion. Required when moving into a new home, upgrading standard of observance, or preparing for Pesach." },
  { q: "How long does a kitchen kashering take?", a: "A typical residential kitchen takes 2–4 hours depending on size and condition. We'll provide a clear time estimate at the site visit." },
  { q: "Can every kitchen be kashered?", a: "Most can. Certain surfaces have limitations under halacha — we'll assess and advise clearly what can be kashered and what may need covering." },
  { q: "Do you work with all minhagim?", a: "Yes — bespoke service for Ashkenazi (Rema), Sephardi (Maran), and Chabad (Baal HaTanya). Tell us your minhag and we'll work to it." },
  { q: "Do you provide written certification?", a: "Yes. On completion of any kashering we provide written documentation confirming the work, standard applied, and date — particularly important for commercial premises." },
  { q: "How far do you travel?", a: "All of Greater London and the Home Counties as standard. For commercial projects we regularly travel to Manchester, Leeds, Gateshead and further." },
];

export const CONTACT = {
  phone: "07877 840 952",
  phoneRaw: "tel:07877840952",
  whatsapp: "https://wa.me/447877840952",
  email: "rabbihgruber@aim.com",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Good to Know", href: "#good-to-know" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];
